import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import PrivateRoute from '../components/widgets/PrivateRoute';
import Login from '../containers/Login';
import Logout from '../containers/Logout';
import HomeWithPersist from '../containers/HomeWithPersist';
import NotFound from '../containers/NotFound';
import OffCanvas from '../components/layout/offcanvas/OffCanvas';
import "../../assets/scss/load-history.scss"
const AppRouter = () => (
    <Router>
        <Switch>
            <Route exact path="/" component={Login} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/logout" component={Logout} />
            <PrivateRoute path="/home/farm/:farmId" component={HomeWithPersist} />
            
            <Route exact path="/aichatroom" render={(props) => 
             <div className={`load-history-chat-bot-container ai_chatbot_container chat-bot-active`}><OffCanvas {...props} isVertexAi={true} /></div>} />
            <Route exact path="/*" component={NotFound} />
        </Switch>
    </Router>
)

export default AppRouter;